import React from 'react';
import './Footer.css';

export default function Footer({ t }) {
  return (
    <footer className="footer">
      <div className="footer-rule" />
      <p className="footer-tagline">{t.tagline}</p>
      <p className="footer-name">Master Dante</p>
      <p className="footer-copy">© {new Date().getFullYear()} — {t.rights}</p>
    </footer>
  );
}
